const SCALE = window.devicePixelRatio || 1;

class TimelineCanvas {
    constructor(container) {
        this.container = container;
        this.canvas = document.createElement('canvas');
        this.canvas.classList.add('timeline');
        this.container.appendChild(this.canvas);
        this.canvasContext = this.canvas.getContext('2d');
        this.pos = { x: 0, y: 0 };
        this.isPlaying = false;
    }

    resize(width, height) {
        this.width = width;
        this.height = height;
        this.canvas.width = this.width * SCALE;
        this.canvas.height = this.height * SCALE;
        this.canvas.style.width = `${this.width}px`;
        this.canvas.style.height = `${this.height}px`;
    }

    clear() {
        this.canvasContext.clearRect(0, 0, this.canvas.width, this.canvas.height);
    }

    draw() {
        this.canvasContext.clearRect(0, 0, this.canvas.width, this.canvas.height);
        this.canvasContext.beginPath();
        this.canvasContext.strokeStyle="white";
        this.canvasContext.moveTo(this.pos.x, 0);
        this.canvasContext.lineTo(this.pos.x, this.canvas.height);
        this.canvasContext.closePath();
        this.canvasContext.stroke();
    }

    update(progress) {
        if (progress > 0) {
            this.pos.x = this.canvas.width * progress;
            this.draw();
        }
    }
}

export { TimelineCanvas }